// src/services/checkInApi.js
import { API_BASE } from './api';

const CHECKIN_API = `${API_BASE}/checkin`;

export async function fetchQuestions() {
  const res = await fetch(`${CHECKIN_API}/questions`);
  if (!res.ok) throw new Error('Failed to load check-in questions.');
  return res.json();
}

export async function submitCheckIn(answers) {
  const res = await fetch(`${CHECKIN_API}/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ answers })
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || 'Failed to submit check-in.');
  return data;
}

export async function emailCheckInResult(email, assessment, selectedSections) {
  const res = await fetch(`${CHECKIN_API}/email-result`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, assessment, selectedSections }),
  });

  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to send result email.");
  return data;
}